import React, { useEffect, useState } from "react";
import "../../HomeWork/Pending/QuestionTypes/QuestionType.css";
import PdfViewer from "../../PdfViewer/PdfViewer";
import moment from "moment";
import { iconData } from "../../../iconData";
import axios from "../../../axios";
import { useSelector } from "react-redux";
import { Player } from "video-react";
import { IP } from "../../../internalServer";
import { useLocation } from "react-router-dom";
import PdfViewActivity from "./PdfViewActivity";
import { Award } from "lucide-react";

export default function ActivityOnReviewSubDetail({
  handlePendingOnreviewSubDetail,
}) {
  const { state } = useLocation();
  const userId = useSelector((state) => state?.user?.currentUser?.id);
  const [pedingSubDetail, setPedingSubDetail] = useState({
    pdfView: false,
    attachment: null,
  });
  const [mideaviewer, setMideaviewer] = useState(false);
  const [homeMain, setHomeMain] = useState([]);
  const [showDetails, setShowDetails] = useState(true);

  const [activityResponse, setActivityResponse] = useState();
  const [responseAttach, setResponseAttach] = useState();
  const [handleVideoClick, setHandleVideoClick] = useState(false);
  const [isClicked, setIsClicked] = useState(false);
  const [isError, setIsError] = useState(false);

  const [isGettingData, setIsGettingData] = useState(true);

  // 🔥 Get entryType and gradeScale from homeMain
  const entryType = homeMain?.entryType || null;
  const gradeScale = homeMain?.gradeScaleId || null;
  const totalMarks = homeMain?.total_marks || 0;

  // Helper function to render grade/marks info
  const renderGradeOrMarksInfo = () => {
    // If entryType is "Grade" - show grade scale
    if (entryType === "Grade" && gradeScale) {
      return (
        <div className="d-flex align-items-center gap-2 flex-wrap">
          <Award size={16} style={{ color: "#6366f1" }} />
          <span
            style={{ fontSize: "0.8rem", color: "#64748b", fontWeight: 500 }}
          >
            Grade Scale:
          </span>
          <span
            style={{ fontSize: "0.9rem", fontWeight: 700, color: "#4338ca" }}
          >
            {gradeScale.name}
          </span>
          <span
            className="badge"
            style={{
              backgroundColor: "#6366f1",
              color: "#fff",
              fontSize: "10px",
            }}
          >
            Grade
          </span>
        </div>
      );
    }

    // If entryType is "Marks" - show total marks
    if (entryType === "Marks") {
      return (
        <div className="d-flex align-items-center gap-2">
          <span
            style={{ fontSize: "0.8rem", color: "#64748b", fontWeight: 500 }}
          >
            Total Marks
          </span>
          <span
            style={{ fontSize: "1.1rem", fontWeight: 700, color: "#0f172a" }}
          >
            {totalMarks || 0}
          </span>
          <span
            className="badge"
            style={{
              backgroundColor: "#28a745",
              color: "#fff",
              fontSize: "10px",
            }}
          >
            Marks
          </span>
        </div>
      );
    }

    // If no entryType or "None" - show total marks (fallback)
    return (
      <div className="d-flex align-items-center gap-2">
        <span style={{ fontSize: "0.8rem", color: "#64748b", fontWeight: 500 }}>
          Total Marks
        </span>
        <span style={{ fontSize: "1.1rem", fontWeight: 700, color: "#0f172a" }}>
          {totalMarks || 0}
        </span>
      </div>
    );
  };

  const handleRemovePdfVivwer = () => {
    setPedingSubDetail({
      ...pedingSubDetail,
      pdfView: false,
      attachment: null,
    });
  };

  const handleClick = (attachment) => {
    setResponseAttach(attachment);
    setIsClicked(!isClicked);
  };

  const handleClickForVideo = (attachment) => {
    setResponseAttach(attachment);
    setHandleVideoClick(!handleVideoClick);
  };

  useEffect(() => {
    const getResponse = async () => {
      try {
        let res = await axios.get(
          `/homework/activity/${state.activityId}/studentResponse/getByStudentAndActivityId/${userId}`,
        );
        let res1 = await axios.get(
          `/homework/activity/getById/${state.activityId}`,
        );
        res1 && setHomeMain(res1.data.data);
        res && setActivityResponse(res.data.data);
        setIsGettingData(false);
      } catch (error) {
        console.log(error);
      }
    };
    getResponse();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const timeHelper = (a) => {
    const dateObj = new Date(a);
    const day = dateObj.getUTCDate().toString().padStart(2, "0");
    const month = (dateObj.getUTCMonth() + 1).toString().padStart(2, "0");
    const year = dateObj.getUTCFullYear();
    const outputDateString = `${day}/${month}/${year}`;
    return outputDateString;
  };

  const handleClickforpdf = (attachment) => {
    setResponseAttach(attachment);
    setMideaviewer(true);
  };

  const attachformat = (para) => {
    const filePath = para;
    const fileName = filePath.split("/").pop();
    const fileNameWithoutId = fileName.split("_")[1];
    return fileNameWithoutId;
  };

  // Helper to get attachment display name
  const getAttachmentName = (attachment) => {
    if (attachment.startsWith("https://") || attachment.startsWith("http://")) {
      try {
        const url = new URL(attachment);
        const hostname = url.hostname.replace("www.", "");

        if (hostname.includes("youtube.com") || hostname.includes("youtu.be")) {
          return "YouTube Video";
        }
        if (hostname.includes("drive.google.com")) {
          return "Google Drive";
        }
        if (hostname.includes("docs.google.com")) {
          return "Google Docs";
        }
        return (
          hostname.split(".")[0].charAt(0).toUpperCase() +
          hostname.split(".")[0].slice(1)
        );
      } catch {
        return "Web Link";
      }
    }
    const ext = attachment.split(".").pop()?.toLowerCase();
    return ext ? ext.toUpperCase() : "File";
  };

  return (
    <>
      {activityResponse ? (
        <div className="d-flex gap-1">
          <div className="w-100">
            {/* ═══════════════════════════════════════════════════
                MODERN HEADER
                ═══════════════════════════════════════════════════ */}
            <div className="d-flex align-items-center gap-3 w-100 mb-4">
              <div
                onClick={() => window.history.back()}
                style={{
                  cursor: "pointer",
                  width: "36px",
                  height: "36px",
                  borderRadius: "10px",
                  background: "#f1f5f9",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  flexShrink: 0,
                }}
              >
                <img
                  src="/HwImg/backArrow.png"
                  alt="Back"
                  style={{ width: "18px" }}
                />
              </div>

              <div className="d-flex flex-column gap-1" style={{ flex: 1 }}>
                <div className="d-flex align-items-center gap-2 flex-wrap">
                  <span
                    style={{
                      fontSize: "1.25rem",
                      fontWeight: 700,
                      color: "#1e293b",
                      lineHeight: 1.3,
                    }}
                  >
                    {homeMain?.name}
                  </span>
                  <span
                    style={{
                      background: "#fff7ed",
                      color: "#c2410c",
                      border: "1px solid #fed7aa",
                      padding: "4px 12px",
                      borderRadius: "999px",
                      fontSize: "0.75rem",
                      fontWeight: 600,
                      textTransform: "uppercase",
                      letterSpacing: "0.4px",
                      whiteSpace: "nowrap",
                    }}
                  >
                    On Review
                  </span>
                  {/* 🆕 Entry Type Badge */}
                  {entryType && entryType !== "None" && (
                    <span
                      style={{
                        background:
                          entryType === "Grade" ? "#6366f1" : "#28a745",
                        color: "#fff",
                        padding: "4px 12px",
                        borderRadius: "999px",
                        fontSize: "0.7rem",
                        fontWeight: 600,
                        whiteSpace: "nowrap",
                      }}
                    >
                      {entryType}
                    </span>
                  )}
                </div>
              </div>

              {/* 🆕 Grade/Marks Info Box */}
              <div
                className="d-flex align-items-center gap-3"
                style={{
                  background: "#f8fafc",
                  border: "1px solid #e2e8f0",
                  padding: "8px 16px",
                  borderRadius: "10px",
                  whiteSpace: "nowrap",
                }}
              >
                {renderGradeOrMarksInfo()}
              </div>
            </div>

            {/* ═══════════════════════════════════════════════════
                ACTIVITY DETAILS CARD — COLLAPSIBLE (Always Open)
                ═══════════════════════════════════════════════════ */}
            <div
              style={{
                backgroundColor: "#f8f9fa",
                border: "1px solid #e9ecef",
                borderRadius: "12px",
                padding: "20px",
                marginBottom: "20px",
              }}
            >
              {/* Collapsible Description */}
              <div
                style={{
                  border: "1px solid #e2e8f0",
                  borderRadius: "16px",
                  overflow: "hidden",
                  background: "#ffffff",
                  boxShadow: "0 2px 10px rgba(0,0,0,0.04)",
                }}
              >
                {/* Header */}
                <div
                  onClick={() => setShowDetails(!showDetails)}
                  className="d-flex justify-content-between align-items-center px-3 py-3 flex-wrap gap-2"
                  style={{
                    cursor: "pointer",
                    background:
                      "linear-gradient(135deg, #fff7ed 0%, #fef3c7 100%)",
                  }}
                >
                  <div className="d-flex flex-column gap-2">
                    <div className="d-flex align-items-center gap-2 flex-wrap">
                      <span
                        style={{
                          background: "#fff",
                          padding: "6px 14px",
                          borderRadius: "999px",
                          fontSize: "13px",
                          fontWeight: 600,
                          color: "#92400e",
                          border: "1px solid #fde68a",
                        }}
                      >
                        📘 {homeMain?.subject_id?.name}
                      </span>
                      <span
                        style={{
                          background: "#fff",
                          padding: "6px 14px",
                          borderRadius: "999px",
                          fontSize: "13px",
                          fontWeight: 600,
                          color: "#7c2d12",
                          border: "1px solid #fed7aa",
                        }}
                      >
                        ⏰ Deadline: {timeHelper(homeMain?.deadline)}
                      </span>
                      <span
                        style={{
                          background: "#fff",
                          padding: "6px 14px",
                          borderRadius: "999px",
                          fontSize: "13px",
                          fontWeight: 600,
                          color: "#7c2d12",
                          border: "1px solid #fed7aa",
                        }}
                      >
                        ✅ Submitted:{" "}
                        {timeHelper(activityResponse?.submitted_on)}
                      </span>
                      {/* 🆕 Entry Type Badge in Description */}
                      {entryType && entryType !== "None" && (
                        <span
                          style={{
                            background:
                              entryType === "Grade" ? "#6366f1" : "#28a745",
                            color: "#fff",
                            padding: "4px 12px",
                            borderRadius: "999px",
                            fontSize: "11px",
                            fontWeight: 600,
                          }}
                        >
                          {entryType}
                        </span>
                      )}
                    </div>
                    <div>
                      <span
                        style={{
                          fontSize: "15px",
                          fontWeight: 700,
                          color: "#92400e",
                        }}
                      >
                        📝 Activity Description
                      </span>
                      <div
                        style={{
                          fontSize: "12px",
                          color: "#78716c",
                          marginTop: "2px",
                        }}
                      >
                        Click to {showDetails ? "hide" : "view"} full
                        description
                      </div>
                    </div>
                  </div>
                  <div
                    style={{
                      width: "36px",
                      height: "36px",
                      borderRadius: "50%",
                      background: "#fff",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      fontSize: "20px",
                      fontWeight: 700,
                      color: "#92400e",
                      flexShrink: 0,
                      userSelect: "none",
                    }}
                  >
                    {showDetails ? "−" : "+"}
                  </div>
                </div>

                {/* Collapsible Body */}
                <div
                  style={{
                    maxHeight: showDetails ? "300px" : "0px",
                    overflow: "hidden",
                    transition: "all 0.35s ease",
                  }}
                >
                  <div
                    className="ActivityDtailText orange-scrollBar"
                    style={{
                      width: "100%",
                      padding: "18px",
                      whiteSpace: "pre-wrap",
                      lineHeight: 1.7,
                      color: "#475569",
                      fontSize: "14px",
                      maxHeight: "260px",
                      overflowY: "auto",
                    }}
                  >
                    {homeMain?.description || "No description available"}
                  </div>
                </div>
              </div>

              {/* Lab Card */}
              {homeMain?.activity_type === "Lab" && homeMain?.lab_ref && (
                <div className="mt-4 mb-2">
                  <div
                    className="p-3"
                    style={{
                      backgroundColor: "#fff7ed",
                      border: "2px solid #f97316",
                      borderRadius: "16px",
                    }}
                  >
                    <div className="d-flex align-items-center gap-3 flex-wrap">
                      <img
                        src={homeMain.lab_ref.thumbnailUrl}
                        alt={homeMain.lab_ref.title}
                        style={{
                          width: "130px",
                          height: "85px",
                          objectFit: "cover",
                          borderRadius: "10px",
                          border: "1px solid #fdba74",
                          flexShrink: 0,
                        }}
                        onError={(e) => {
                          e.target.style.display = "none";
                        }}
                      />
                      <div style={{ flex: 1, minWidth: 0 }}>
                        <div className="d-flex align-items-center gap-2 mb-1 flex-wrap">
                          <span
                            style={{
                              fontWeight: 700,
                              color: "#c2410c",
                              fontSize: "1.05rem",
                            }}
                          >
                            {homeMain.lab_ref.title}
                          </span>
                          <span
                            className="badge rounded-pill"
                            style={{
                              backgroundColor: "#ffedd5",
                              color: "#c2410c",
                              fontSize: "0.75rem",
                              padding: "6px 10px",
                            }}
                          >
                            {homeMain.lab_ref.resourceType}
                          </span>
                        </div>
                        <p
                          style={{
                            color: "#7c2d12",
                            fontSize: "0.85rem",
                            lineHeight: 1.5,
                            marginBottom: "8px",
                            display: "-webkit-box",
                            WebkitLineClamp: 2,
                            WebkitBoxOrient: "vertical",
                            overflow: "hidden",
                          }}
                        >
                          {homeMain.lab_ref.description}
                        </p>
                        <span style={{ fontSize: "0.8rem", color: "#9a3412" }}>
                          {homeMain?.lab_ref?.estimatedDurationMinutes} mins
                        </span>
                      </div>
                      <button
                        className="btn"
                        style={{
                          backgroundColor: "#f97316",
                          color: "#ffffff",
                          borderRadius: "10px",
                          padding: "8px 20px",
                          fontWeight: 600,
                          fontSize: "0.9rem",
                          border: "none",
                          whiteSpace: "nowrap",
                        }}
                        onClick={() => {
                          const previewData = {
                            selectedLab: homeMain.lab_ref,
                            activityData: {
                              title: homeMain.name,
                              description: homeMain.description,
                              className: homeMain?.standard_id?.name,
                              subjectName: homeMain?.subject_id?.name,
                              chapterName:
                                homeMain?.chapter_id?.chapterName || "",
                              duration: homeMain?.duration || "20 minutes",
                            },
                          };
                          localStorage.setItem(
                            "activityPreviewData",
                            JSON.stringify(previewData),
                          );
                          const features = [
                            "toolbar=no",
                            "location=no",
                            "directories=no",
                            "status=no",
                            "menubar=no",
                            "scrollbars=yes",
                            "resizable=yes",
                            "fullscreen=yes",
                            `width=${window.screen.availWidth}`,
                            `height=${window.screen.availHeight}`,
                            "top=0",
                            "left=0",
                          ].join(",");
                          const newWindow = window.open(
                            "/activity-lab-preview.html",
                            "_blank",
                            features,
                          );
                          if (newWindow) {
                            newWindow.moveTo(0, 0);
                            newWindow.resizeTo(
                              window.screen.availWidth,
                              window.screen.availHeight,
                            );
                            newWindow.focus();
                          }
                        }}
                      >
                        Open Activity
                      </button>
                    </div>
                  </div>
                </div>
              )}

              {/* Activity Attachments — NO SUBJECT NAME */}
              <div className="d-flex flex-wrap gap-3 mt-4">
                {homeMain?.attachments?.length > 0 &&
                  homeMain?.attachments?.map((attachment, index) => (
                    <div
                      className="flex cursor-pointer"
                      key={index}
                      onClick={() => {
                        const fileType = attachment.split(".").pop();
                        if (
                          fileType === "jpg" ||
                          fileType === "jpeg" ||
                          fileType === "png" ||
                          fileType === "mp4" ||
                          fileType === "JPG" ||
                          fileType === "JPEG" ||
                          fileType === "PNG" ||
                          fileType === "MP4"
                        ) {
                          handleClick(attachment);
                        } else if (
                          fileType === "pdf" ||
                          fileType === "PDF" ||
                          fileType === "ppt" ||
                          fileType === "PPT" ||
                          fileType === "PPTX" ||
                          fileType === "pptx"
                        ) {
                          handleClickforpdf(attachment);
                        }
                      }}
                    >
                      <>
                        {attachment.split(".").pop() === "jpg" ||
                        attachment.split(".").pop() === "jpeg" ||
                        attachment?.split(".").pop() === "JPEG" ||
                        attachment?.split(".").pop() === "JPG" ||
                        attachment?.split(".").pop() === "PNG" ||
                        attachment?.split(".").pop() === "mp4" ||
                        attachment?.split(".").pop() === "MP4" ||
                        attachment.split(".").pop() === "png" ? (
                          <div
                            onClick={() => {
                              if (!isError) handleClick(attachment);
                            }}
                            style={
                              isError
                                ? { pointerEvents: "none", opacity: 0.5 }
                                : {}
                            }
                            className="d-flex gap-2 p-1"
                          >
                            <div className="d-flex align-items-center">
                              <img
                                src={`${iconData?.find((i) => i.extension === attachment?.split(".").pop())?.icon}`}
                                alt=""
                                className="w-8"
                              />
                            </div>
                          </div>
                        ) : attachment.split(".").pop() === "pdf" ? (
                          <div
                            className="d-flex align-items-center"
                            onClick={() => handleClickforpdf(attachment)}
                          >
                            <img
                              className="w-8"
                              src={`${iconData?.find((i) => i.extension === attachment?.match(/\.([^.]+)$/)[1])?.icon}`}
                              alt=""
                            />
                          </div>
                        ) : (
                          attachment.startsWith("https://") && (
                            <div
                              onClick={() =>
                                window.open(
                                  attachment,
                                  "_blank",
                                  "noopener,noreferrer",
                                )
                              }
                              className="flex gap-2 items-center"
                            >
                              <div className="mb-2">
                                <img
                                  src="/images/link-icon.png"
                                  alt=""
                                  className="w-10"
                                  style={{ width: 40, height: 40 }}
                                />
                              </div>
                              <div className="text-sm font-weight-medium text-center">
                                <div
                                  style={{
                                    maxWidth: "180px",
                                    overflow: "hidden",
                                    textOverflow: "ellipsis",
                                    whiteSpace: "nowrap",
                                  }}
                                >
                                  {getAttachmentName(attachment)}
                                </div>
                              </div>
                            </div>
                          )
                        )}
                      </>
                      {attachment.startsWith("https://") ? null : (
                        <div
                          className="pdf_detail font-semibold"
                          style={{ marginLeft: "5px" }}
                        >
                          <div
                            className="pdf-txt2"
                            title={attachformat(attachment)}
                            style={{
                              textOverflow: "ellipsis",
                              overflow: "hidden",
                              whiteSpace: "nowrap",
                              maxWidth: "100px",
                            }}
                          >
                            {attachformat(attachment)}
                          </div>
                        </div>
                      )}
                    </div>
                  ))}
              </div>
            </div>

            {/* ═══════════════════════════════════════════════════
                MY ANSWER CARD (STUDENT RESPONSE)
                ═══════════════════════════════════════════════════ */}
            <div
              style={{
                backgroundColor: "#f8f9fa",
                border: "1px solid #e9ecef",
                borderRadius: "12px",
                padding: "20px",
                marginBottom: "20px",
              }}
            >
              <div
                style={{
                  fontSize: "0.8rem",
                  fontWeight: 700,
                  color: "#6c757d",
                  textTransform: "uppercase",
                  letterSpacing: "0.6px",
                  marginBottom: "14px",
                  borderBottom: "1px solid #dee2e6",
                  paddingBottom: "8px",
                }}
              >
                📝 My Answer
              </div>

              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  marginBottom: "12px",
                }}
              >
                <span
                  style={{
                    fontWeight: 600,
                    color: "#475569",
                    fontSize: "14px",
                  }}
                >
                  Submitted Response
                </span>
                <span
                  style={{
                    background: "#fff7ed",
                    color: "#c2410c",
                    border: "1px solid #fed7aa",
                    padding: "4px 12px",
                    borderRadius: "999px",
                    fontSize: "0.75rem",
                    fontWeight: 600,
                  }}
                >
                  {entryType === "Grade"
                    ? "Grade Based"
                    : `${homeMain?.total_marks || 0} Marks`}
                </span>
              </div>

              <div style={{ position: "relative" }} className="mt-3 mb-3">
                <textarea
                  placeholder="Type to write your answer here."
                  className="textInputQuestion p-3"
                  maxLength={2500}
                  value={activityResponse?.description}
                  readOnly
                  style={{
                    width: "100%",
                    borderRadius: "10px",
                    border: "1px solid #e2e8f0",
                    background: "#ffffff",
                    minHeight: "120px",
                  }}
                ></textarea>
                <div
                  className="maxWordCount"
                  style={{
                    position: "absolute",
                    bottom: "10px",
                    right: "10px",
                  }}
                >
                  {activityResponse?.description?.length || 0}/2500
                </div>
              </div>

              {/* Student Response Attachments */}
              <div className="d-flex flex-wrap gap-3">
                {activityResponse?.attachments?.length > 0 &&
                  activityResponse?.attachments?.map((attachment, index) => (
                    <div
                      className="flex cursor-pointer"
                      key={index}
                      onClick={() => {
                        const fileType = attachment.split(".").pop();
                        if (
                          fileType === "jpg" ||
                          fileType === "jpeg" ||
                          fileType === "png" ||
                          fileType === "mp4" ||
                          fileType === "JPG" ||
                          fileType === "JPEG" ||
                          fileType === "PNG" ||
                          fileType === "MP4"
                        ) {
                          handleClick(attachment);
                        } else if (
                          fileType === "pdf" ||
                          fileType === "PDF" ||
                          fileType === "ppt" ||
                          fileType === "PPT" ||
                          fileType === "PPTX" ||
                          fileType === "pptx"
                        ) {
                          handleClickforpdf(attachment);
                        }
                      }}
                    >
                      <>
                        {attachment.split(".").pop() === "jpg" ||
                        attachment.split(".").pop() === "jpeg" ||
                        attachment?.split(".").pop() === "JPEG" ||
                        attachment?.split(".").pop() === "JPG" ||
                        attachment?.split(".").pop() === "PNG" ||
                        attachment?.split(".").pop() === "mp4" ||
                        attachment?.split(".").pop() === "MP4" ||
                        attachment.split(".").pop() === "png" ? (
                          <div
                            onClick={() => {
                              if (!isError) handleClick(attachment);
                            }}
                            style={
                              isError
                                ? { pointerEvents: "none", opacity: 0.5 }
                                : {}
                            }
                            className="d-flex gap-2 p-1"
                          >
                            <div className="d-flex align-items-center">
                              <img
                                src={`${iconData?.find((i) => i.extension === attachment?.split(".").pop())?.icon}`}
                                alt=""
                                className="w-8"
                              />
                            </div>
                          </div>
                        ) : attachment.split(".").pop() === "pdf" ? (
                          <div
                            className="d-flex align-items-center"
                            onClick={() => handleClickforpdf(attachment)}
                          >
                            <img
                              className="w-8"
                              src={`${iconData?.find((i) => i.extension === attachment?.match(/\.([^.]+)$/)[1])?.icon}`}
                              alt=""
                            />
                          </div>
                        ) : (
                          attachment.startsWith("https://") && (
                            <div
                              onClick={() =>
                                window.open(
                                  attachment,
                                  "_blank",
                                  "noopener,noreferrer",
                                )
                              }
                              className="flex gap-2 items-center"
                            >
                              <div className="mb-2">
                                <img
                                  src="/images/link-icon.png"
                                  alt=""
                                  className="w-10"
                                  style={{ width: 40, height: 40 }}
                                />
                              </div>
                              <div className="text-sm font-weight-medium text-center">
                                <div
                                  style={{
                                    maxWidth: "180px",
                                    overflow: "hidden",
                                    textOverflow: "ellipsis",
                                    whiteSpace: "nowrap",
                                  }}
                                >
                                  {getAttachmentName(attachment)}
                                </div>
                              </div>
                            </div>
                          )
                        )}
                      </>
                      {attachment.startsWith("https://") ? null : (
                        <div
                          className="pdf_detail font-semibold"
                          style={{ marginLeft: "5px" }}
                        >
                          <div
                            className="pdf-txt2"
                            title={attachformat(attachment)}
                            style={{
                              textOverflow: "ellipsis",
                              overflow: "hidden",
                              whiteSpace: "nowrap",
                              maxWidth: "100px",
                            }}
                          >
                            {attachformat(attachment)}
                          </div>
                        </div>
                      )}
                    </div>
                  ))}
              </div>
            </div>
          </div>
        </div>
      ) : isGettingData ? (
        <div
          className="d-flex flex-column align-items-center justify-content-center"
          style={{ minHeight: "600px" }}
        >
          <div className="position-relative">
            <div
              className="spinner-grow text-warning"
              role="status"
              style={{ width: "60px", height: "60px" }}
            >
              <span className="visually-hidden">Loading...</span>
            </div>
            <div
              className="spinner-grow text-primary position-absolute top-0 start-50 translate-middle"
              style={{ width: "40px", height: "40px", animationDelay: "0.2s" }}
            >
              <span className="visually-hidden">Loading...</span>
            </div>
          </div>
          <span
            className="mt-4 text-muted"
            style={{
              fontSize: "15px",
              fontWeight: 500,
              letterSpacing: "0.3px",
            }}
          >
            Please wait...
          </span>
        </div>
      ) : (
        <div className="ContainerPendingSubDetail d-flex p-4 gap-1">
          <div className="d-flex justify-content-center h-20 align-items-center w-100">
            <span
              className="badge bg-light text-dark rounded-pill px-4 py-3"
              style={{ fontSize: "1.2rem", letterSpacing: "0.5px" }}
            >
              📭 Activity Not Found
            </span>
          </div>
        </div>
      )}
      {mideaviewer && (
        <PdfViewActivity
          setMideaviewer={setMideaviewer}
          attachment={responseAttach}
        />
      )}
      {isClicked &&
        (responseAttach.split(".").pop() === "mp4" ||
        responseAttach.split(".").pop() === "MP4" ? (
          <div className="fullSizeImg">
            <div className="SubfullSizeImg">
              <video className="videoPlayer" controls>
                <source
                  src={IP + responseAttach.replace(/^\./, "")}
                  type="video/mp4"
                />
              </video>
              <div>
                <img
                  className="crossIconImgQue"
                  onClick={handleClick}
                  src="/DCM-img/crossIcon.svg"
                  alt="Up Arrow"
                />
              </div>
            </div>
          </div>
        ) : (
          <div className="fullSizeImg">
            <div className="SubfullSizeImg">
              {!isError ? (
                <>
                  <img
                    className="imgMain"
                    src={IP + responseAttach?.replace(/^\./, "")}
                    alt="Full-size"
                    onError={(e) => {
                      setIsError(true);
                    }}
                  />
                  <div>
                    <img
                      className="crossIconImgQue"
                      onClick={handleClick}
                      src="/images/cross.png"
                      alt="Up Arrow"
                    />
                  </div>
                </>
              ) : (
                <div
                  className="fullSizeImg"
                  style={{ display: "flex", flexDirection: "column" }}
                >
                  <img
                    onClick={() => {
                      setIsError(false);
                      handleClick();
                    }}
                    src="/images/cross.png"
                    alt="Up Arrow"
                    style={{ position: "absolute", top: "75px", right: "40%" }}
                  />
                  <img
                    src="/images/no-photo1.png"
                    alt="img"
                    style={{ width: "25%" }}
                  />
                  <p
                    style={{
                      color: "red",
                      fontSize: "20px",
                      fontWeight: "500",
                      marginRight: "35px",
                    }}
                  >
                    Error!! failed to load the requested file!
                  </p>
                </div>
              )}
            </div>
          </div>
        ))}
      {handleVideoClick && (
        <div className="fullSizeImg">
          <div className="SubfullSizeImgVideo">
            <div>
              <video className="videoPlayer" controls>
                <source
                  src={IP + responseAttach.replace(/^\./, "")}
                  type="video/mp4"
                />
              </video>
            </div>
            <div>
              <img
                className="crossIconImgQue"
                onClick={handleClickForVideo}
                src="/DCM-img/crossIcon.svg"
                alt="Up Arrow"
              />
            </div>
          </div>
        </div>
      )}
    </>
  );
}
